module.exports = __webpack_public_path__ + "static/media/poster16.2eb7de9a.png";